import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Demographics from "./pages/Demographics";
import Survey from "./components/Survey";
import SurveySuccess from "./components/surveySuccess";

function App() {
  return (
    <Router basename="surveyv2">
      <Routes>
        <Route path="/" element={<Demographics />} />
        <Route path="/survey/:studentuuid/:studentssid" element={<Survey />} />
        <Route path="/survey-success/:studentuuid/:studentssid" element={<SurveySuccess />} />
      </Routes>
    </Router>
  );
}

export default App;
